module.exports = __webpack_public_path__ + "static/media/message-nodata.c6c81397.png";